<dx-popup
  [showTitle]="true"
  [title]="dialogTitle"
  [(visible)]="displayDialog"
  [width]="700"
  [height]="'auto'"
  [resizeEnabled]="true"
  [showCloseButton]="true"
  (onHidden)="closeDialog()"
>

  <div class="dialog-line">
    <div class="label" title="Unité de production">Unité de production <span class="danger-color">*</span></div>
    <div class="value">
      <dx-lookup
        [dataSource]="[this.uniteProduction]"
        [value]="this.uniteProduction?.id"
        valueExpr="id"
        displayExpr="libelle"
        [disabled]="true"
      >
      </dx-lookup>
    </div>
  </div>


  <form (ngSubmit)="save()" [formGroup]="form">

    <div id="loadingZone">
      <div class="dialog-line">
        <div class="label" title="Fournisseur">Fournisseur <span class="danger-color">*</span></div>
        <div class="value">
          <dx-lookup
            [dataSource]="this.fournisseurs"
            [value]="this.selectedFournisseurId"
            valueExpr="fournisseurId"
            displayExpr="fournisseurLibelle"
            [searchEnabled]="true"
            formControlName="fournisseur"
            (onSelectionChanged)="onFournisseurChange($event)"
            [disabled]="!isFournisseursListReady"
          >
            <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
          </dx-lookup>
        </div>
      </div>

      <div class="dialog-line">
        <div class="label" title="Date de livraison">Date de livraison <span class="danger-color">*</span></div>
        <div class="value">
          <dx-calendar
            #calendar
            id="calendar"
            [min]="minDate"
            [disabled]="!isCalendarReady"
            [firstDayOfWeek]="0"
            formControlName="dateLivraison"
            [disabledDates]="disabledDates"
            cellTemplate="custom">
          <span *dxTemplate="let cell of 'custom'"
                [ngClass]="getCellCssClass(cell)">
            {{ cell.text }}
          </span>
          </dx-calendar>
        </div>
      </div>
    </div>

    <div *ngIf="bonCf?.listeBesoinId" class="dialog-line">
      <div class="label" title="Choix de la quantité">Quantité de référence <span class="danger-color">*</span></div>
      <div class="value">
        <dx-select-box
          [items]="choixQtes"
          formControlName="choixQte"
          valueExpr="value"
          displayExpr="label"
        >
          <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
        </dx-select-box>
      </div>
    </div>

    <div id="button-container" class="custom-button-container-right">
      <yo-button
        type="submit"
        iconClass="fas fa-save"
        label="Réassigner"
        [theme]="ButtonThemeEnum.SAVE">
      </yo-button>
      <yo-button
        iconClass="fas fa-times"
        (onClick)="closeDialog()"
        [theme]="ButtonThemeEnum.CANCEL">
      </yo-button>
    </div>
  </form>


</dx-popup>

